module.exports = __webpack_public_path__ + "static/img/airport-blue.a786e3b1.svg";